

import React from "react"

/**
 * Container svg icon with defined properties as per UI
 * @returns ContainerSvg JSX
 */

export const ContainerSvg = (props: any) => {
    const {className} = props
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="6.02301" cy="14.9996" r="1.38238" stroke="#717171" />
            <circle cx="13.8824" cy="14.9996" r="1.38238" stroke="#717171" />
            <circle cx="17.8824" cy="14.8824" r="1.38238" stroke="#717171" />
            <path d="M3 10.7337L4.30515 7.267H7.17649M3 10.7337V15.0005H4.62244M3 10.7337H7.17649V7.267M9.26473 15.0005V7.267H7.17649M9.26473 15.0005L7.5 15M9.26473 15.0005H11.2225M12.1347 15.0005H11.2225M15 15L16.5673 15.0005M19.5224 15.0003L21 15.0002V7H11.2225V15.0005" stroke="#717171" />
        </svg>
    )
}
